import { COMPANY_INFO_QUEREY } from "@/apis/gql/apolloClient";
import type { Company } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { useQuery } from "@apollo/client";

export const useGetCompanyInfo = () => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    companyInfo: { companyDescription: string; companyInfoId: string };
    company: Pick<Company, "thirteenBType">;
  }>(COMPANY_INFO_QUEREY, {
    variables: { tenantId },
  });

  return {
    companyInfo: data?.companyInfo,
    company: data?.company,
    error,
    loading,
    refetch,
  };
};
